import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueTheMask from "vue-the-mask";
// import VueYandexMetrika from "vue3-yandex-metrika";

import "boxicons/css/boxicons.min.css";

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

import "gsap";

import "@fontsource/montserrat/200.css";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/800.css";

import "@fontsource/nunito-sans";

import i18n from "./i18n";

if (process.env.VUE_APP_PROD === "true") {
  createApp(App)
    .use(store)
    .use(router)
    .use(ElementPlus)
    .use(i18n)
    .use(VueTheMask)
    .mount("#app");
} else {
  createApp(App)
    .use(store)
    .use(router)
    .use(ElementPlus)
    .use(i18n)
    .use(VueTheMask)
    .mount("#app");
}
